/**
 * API 베이스 URL — CRA 빌드 시 주입.
 * - 비우면 상대 경로(예: `/order/...`) → webpack devServer 프록시가 실제 백엔드로 넘김
 * - 채우면 브라우저가 해당 origin으로 직접 요청(CORS 필요). 끝의 `/` 는 제거.
 * @see craco.config.js — 프록시 대상: REACT_APP_API_BASE_URL 또는 DEV_PROXY_TARGET
 */

/** 끝의 `/` 는 제거 — `https://host/api/` + `/payment/confirm` 이중 슬래시·404 방지 */
export function normalizeApiBaseUrl(raw: string | undefined): string {
  if (raw === undefined || raw === '') return '';
  return String(raw).trim().replace(/\/+$/, '');
}

export const API_BASE_URL = normalizeApiBaseUrl(process.env.REACT_APP_API_BASE_URL);

/**
 * 클래스 썸네일 등 API가 `/uploads/...` 처럼 주는 경로 — REACT_APP_API_BASE_URL 이 있으면 해당 origin에 붙여 img src 로 사용
 * (비우면 상대 경로 그대로 — devServer 프록시·동일 오리진)
 */
export function resolvePublicFileUrlForImg(url: string | undefined | null): string | undefined {
	if (url == null || typeof url !== 'string') return undefined;
	const u = url.trim();
	if (!u) return undefined;
	if (/^(https?:)?\/\//i.test(u) || u.startsWith('data:') || u.startsWith('blob:')) return u;
	if (u.startsWith('/') && API_BASE_URL) return `${API_BASE_URL}${u}`;
	return u;
}

const AUTH_REFRESH_PATH_RAW = (process.env.REACT_APP_AUTH_REFRESH_PATH || '/auth/access-token').trim();

/** 토큰 갱신 POST 경로 (항상 `/` 로 시작) */
export const AUTH_REFRESH_PATH = AUTH_REFRESH_PATH_RAW.startsWith('/')
  ? AUTH_REFRESH_PATH_RAW
  : `/${AUTH_REFRESH_PATH_RAW}`;

/** POST 토큰 갱신 전체 URL (프록시 모드에서는 path 만 — same-origin) */
export function getAuthRefreshUrl(): string {
  return API_BASE_URL ? `${API_BASE_URL}${AUTH_REFRESH_PATH}` : AUTH_REFRESH_PATH;
}
